import styled from 'styled-components';
import { Badge } from 'antd';

export const FirstBadge = styled(Badge)`
	.ant-badge-count {
		background-color: transparent !important;
		color: #000 !important;
		border: none !important;
		box-shadow: none !important;
		font-size: ${({ theme }) => theme.sizes.fonts.fs_xs};
	}

	@media (max-width: 1331px) {
		.ant-badge-count {
			font-size: 12px;
		}
	}
`;

export const CountBadge = styled(Badge)`
	.ant-badge-count {
		background-color: ${({ theme }) => theme.palette.secondary['150']} !important;
		color: ${({ theme }) => theme.palette.secondary['300']} !important;
		font-weight: bold !important;
		height: 20px !important;
		width: 20px !important;
		border-radius: ${({ theme }) => theme.border.border_radius.br_sm} !important;
		display: flex !important;
		align-items: center !important;
		justify-content: center !important;
		box-shadow: none !important;
		font-size: 12px !important;
		padding: 2px !important;
	}

	@media (max-width: 1331px) {
		.ant-badge-count {
			font-size: 11px;
		}
	}
`;

export const BadgesContainer = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
`;

export const TooltipContent = styled.div`
	max-height: 200px;
	overflow-y: auto;

	> div {
		padding: 4px 0;

		&:not(:last-child) {
			border-bottom: 1px solid rgba(0, 0, 0, 0.06);
		}
	}
`;
